import { Injectable } from "@angular/core";
import { User } from "../user/user";
import * as jwt_decode from "jwt-decode";

const KEY = "biotech.authToken";

@Injectable({
  providedIn: "root",
})
export class TokenService {
  hasToken() {
    return !!this.getToken();
  }

  setToken(token: string) {
    window.localStorage.setItem(KEY, token);
  }

  getToken(): any {
    return JSON.parse(window.localStorage.getItem(KEY));
  }

  removeToken() {
    window.localStorage.removeItem(KEY);
  }

  hasValidDate() {
    const token = this.getToken();
    const user = jwt_decode(token.token.accessToken) as User;
    return Date.now() <= parseInt(user.exp) * 1000;
  }
}
